import { render, staticRenderFns } from "./pdfview.vue?vue&type=template&id=3a5a012b&"
import script from "./pdfview.vue?vue&type=script&lang=js&"
export * from "./pdfview.vue?vue&type=script&lang=js&"
import style0 from "./pdfview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports